<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_3"></a><a id="p9000f1609970003001">
</a><p class="booktitle">SEW MANY BAGS SEW LITTLE TIME</p><p class="book-subtitle"><strong>OVER 30 STYLISH BAGS AND SIMPLE ACCESSORIES</strong></p><p class="book-title-author"><strong>SALLY SOUTHERN</strong></p><div class="book-title-imprint"><img alt="" src="images/p9000f160g3001.png" width="13.43013%"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6b90472c